import React from 'react';
import Input from './Input.react';
import BarcodeReader from 'react-barcode-reader';
import PropTypes from 'prop-types';

interface BarCodeInputProps {
    name?: string;
    onChange?: (...args: unknown[]) => unknown;
}

export default class BarCodeInput extends React.Component<BarCodeInputProps> {
	static propTypes = {
        name: PropTypes.string,
        onChange: PropTypes.func,
    };

    handleScan(data) {
        if (data) {
            /* some devices return ---xxx--- */
            data = data.replace(/-/g, '');
        }
        this.props.onChange(this.props.name, data);
        let list = document.querySelectorAll("button[type='submit']");

        if (list && list.length > 0) {
            list.item(0).click();
        }
    }

    handleError(err) {
        console.error("ERROR", err);
    }

	render() {

        return (
            <div>
                <BarcodeReader
                    avgTimeByChar={30}
                    minLength={3}
                    onError={this.handleError}
                    onScan={this.handleScan}
                />
                <Input {...this.props} />
            </div>
        );
    }
}
